import { render } from "./event-channel-inviting.vue?vue&type=template&id=e0f9aabc&lang=pug"
import script from "./event-channel-inviting.vue?vue&type=script&lang=js"
export * from "./event-channel-inviting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__